import { mapGetters } from 'vuex';
import MenuItems from './menu-items';
import CourseMixin from '@/mixins/templates/course';
import ContentSyncMixin from '@/mixins/content-sync';
import ContentType from '@/helpers/contentType';
import { ABtn } from '@maisaedu/ui-components-a-btn';

export default {
  mixins : [CourseMixin, ContentSyncMixin],
  props  : {
    isOpen: {
      type    : Boolean,
      default : true
    },
    topics: {
      type    : Array,
      default : () => ([])
    },
    context: {
      type    : Object,
      default : () => ({})
    }
  },
  components: {
    MenuItems,
    ABtn
  },
  data() {
    return {
      showMenu           : this.isOpen,
      hasScrollMenuItems : false,
      ContentType
    };
  },
  watch: {
    isOpen(newValue) {
      this.showMenu = newValue;
    }
  },
  computed: {
    ...mapGetters({
      getterUserRoleContext : 'plataforma/user/getterUserContext',
      getterContent         : 'plataforma/newContent/getterContent'
    }),
    computedProgress() {
      return parseFloat(this.topics.filter(topic => topic.viewed).length / this.topicsCountingProgress * 100);
    },
    totalViewedTopics() {
      return this.topics.reduce((count, topic) => {
        return topic.viewed ? count + 1 : count;
      }, 0);
    },
    topicsCountingProgress() {
      return this.topics.filter(topic => topic.isRecordProgress).length;
    }
  },
  mounted() {
    this.checkHasScroll();
  },
  methods: {
    scrollToTopic(topicId) {
      const elementOffsetTop = document.getElementById(topicId);

      if (elementOffsetTop) {
        if (this.$vuetify.breakpoint.smAndDown) {
          this.$emit('close-menu');
        }

        window.scrollTo({
          top      : elementOffsetTop.offsetTop - 64,
          behavior : 'smooth'
        });
      }
    },
    checkHasScroll() {
      this.hasScrollMenuItems = this.$refs.menuItems.$el.scrollHeight > this.$refs.menuItems.$el.clientHeight;
    },
    onResize() {
      this.checkHasScroll();
    }
  }
};
